export class CreateConnectionLink {
  public connection_name = '';
  public display_name = '';
  public validity = '';
  public allowed_visits = '';
}
